import { Box, Spinner, SpaceBetween } from '@cloudscape-design/components';

interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label = 'Loading...' }: LoadingStateProps) {
  return (
    <Box textAlign="center" padding={{ top: 'xxxl', bottom: 'xxxl' }}>
      <SpaceBetween size="s" alignItems="center">
        <Spinner size="large" />
        <Box color="text-body-secondary">{label}</Box>
      </SpaceBetween>
    </Box>
  );
}
